import { Stack } from '@mui/material';

import { api } from 'common';
import { FlowDefinition } from 'vivaa-api';

import { HIE_GET_DOCUMENTS_FORMAT_VARIANTS } from './Variants';
import { BlockDurationField } from '../../ConfigFields/Duration';
import { BlockSelectField, ParentBlockSelectField } from '../../ConfigFields/SelectField';
import { useSelectedNodeField } from '../../ConfigFields/useSelectedNodeField';

const HieDocumentFormat = api.FlowDefinition.HieGetDocuments.HieDocumentFormat;
type HieDocumentFormat = api.FlowDefinition.HieGetDocuments.HieDocumentFormat;

const { DurationUnits } = FlowDefinition;
type DurationUnits = FlowDefinition.DurationUnits;

const PATIENT_SOURCE_HELPER_TEXT = `Select which upstream block to pull Patient HIE ID from.`;

const DOCUMENT_FORMAT_OPTIONS = [
  { value: HieDocumentFormat.ConsolidatedData, label: 'FHIR Format (JSON)' },
  { value: HieDocumentFormat.ConsolidatedDataPdf, label: 'FHIR Format (PDF)' },
  { value: HieDocumentFormat.ConsolidatedDataHtml, label: 'FHIR Format (HTML)' },
  { value: HieDocumentFormat.BulkDownloadUrls, label: 'PDF, HTML' },
];

export function HieGetDocumentsFormFields() {
  const { value: documentFormat } =
    useSelectedNodeField<HieDocumentFormat>('config.documentFormat');
  const { Config } = (documentFormat
    ? HIE_GET_DOCUMENTS_FORMAT_VARIANTS[documentFormat]
    : null) ?? {
    Config: null,
  };

  return (
    <Stack spacing={2}>
      <ParentBlockSelectField
        fieldName="config.sourceBlock.sourceBlockName"
        label="HIE Query Source"
        required
        helperText={PATIENT_SOURCE_HELPER_TEXT}
      />
      <BlockSelectField
        fieldName="config.documentFormat"
        label="Document Format"
        required
        options={DOCUMENT_FORMAT_OPTIONS}
      />
      {Config && <Config />}
      <BlockDurationField
        fieldName="config.timeout"
        unitFieldNameSuffix="units"
        required={true}
        allowedUnits={[DurationUnits.Hours, DurationUnits.Minutes, DurationUnits.Seconds]}
        toggleLabel="Timeout"
        valueLabel="Timeout (fail after duration)"
        valueHelperText="Will fail if block does not complete after duration"
      />
    </Stack>
  );
}
